<div class="container-fluid">

  <h4 class="card-title mt-5 mb-5 text-center">{{title}}</h4>
  <div class="text-center"><button type="button" (click)="clickAnswer(true)" class="btn mb-3 mr-3 btn-gradient-primary btn-rounded btn-fw">{{notif ? "OK" : "Так"}}</button>
    <button  type="button" *ngIf="!notif" (click)="clickAnswer(false)" class=" mb-3 mr-3 btn btn-gradient-secondary btn-rounded btn-fw">Ні</button></div>
</div>
